/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsissuedoorprice3Inputs */

const en_ticketsissuedoorprice3 = /** @type {(inputs: Ticketsissuedoorprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the amount at the door in euros, for example 5.`)
};

const de_ticketsissuedoorprice3 = /** @type {(inputs: Ticketsissuedoorprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib den Betrag vor Ort in Euro an, zum Beispiel 5.`)
};

/**
* | output |
* | --- |
* | "Enter the amount at the door in euros, for example 5." |
*
* @param {Ticketsissuedoorprice3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsissuedoorprice3 = /** @type {((inputs?: Ticketsissuedoorprice3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsissuedoorprice3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsissuedoorprice3(inputs)
	return de_ticketsissuedoorprice3(inputs)
});
export { ticketsissuedoorprice3 as "ticketsIssueDoorPrice" }